var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{staticClass:"nav-list-item__link",class:{active: _vm.show},attrs:{"to":_vm.$prismic.linkResolver(_vm.document.primary.sl_link)}},[_vm._v("\n    "+_vm._s(_vm.document.primary.sl_text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }